/**
 * Localisation event bus listener for main App.
 */
import Vue from 'vue';
// import { locale as dxLocale } from 'devextreme/localization';

import { checkLocaleSupport, getMessagesAsync } from '@/helpers/i18n.js';

export default {

    created: function () {
        // use stored locale if available
        const locale = this.$store.getters['ux/getLocale'];
        this.onLocaleChange(locale);
    },

    beforeMount: function () {
        this.$eventBus.$on('locale-change', this.onLocaleChange);
    },

    beforeDestroy: function () {
        this.$eventBus.$off('locale-change', this.onLocaleChange);
    },

    methods: {
        /**
         * App event listener for locale change
         **/
        onLocaleChange: function (locale) {
            // limit change to available locales
            if (!checkLocaleSupport(locale)) {
                return new Error(`Locale "${locale}" is not supported!`);
            }

            return getMessagesAsync(this.$i18n, locale)
                .then(this.setI18nLanguage)
                .catch(console.error);
        },

        setI18nLanguage: function (locale) {
            // set vue-i18n locale
            this.$i18n.locale = locale;

            // set locale to <html lang />
            document.querySelector('html').setAttribute('lang', locale);

            // devextreme locale is set in plugins/dev-extreme
            window.dxLocale && window.dxLocale(locale);

            // Uppy uses its own localisation strings which are
            // configured in the components that use Uppy

            // moment.js (DEPRECATED)
            //Vue.prototype.$moment.locale(locale);

            // axios Accept-Language header (PreferredLocale param is handled in api/svc)
            if (this.$axios.defaults?.headers?.common) {
                Vue.prototype.$axios.defaults.headers.common['Accept-Language'] = locale;
            }

            // during initial load locale is the stored value
            if (this.$store.getters['ux/getLocale'] !== locale) {
                // save locale to store
                this.$store.commit('ux/setLocale', locale);

                // reset locale-sensitive stores.
                // pages re-fetch triggered from SvcPagesMixin.
                this.$store.commit('pages/RESET');
                this.$store.commit('profileArticles/RESET');

                // refresh App and the displayed page
                this.$eventBus.$emit('page-update');
            }
            else {
                this.$eventBus.$emit('page-refresh');
            }

            return Promise.resolve();
        }
    }
};
